<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-10-14 10:10:46
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-25 16:01:48
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/exhibitionManage/components/changeCouponStatus.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="520px" @close="handleClose">
    <el-form label-width="80px" :model="state.form">
      <el-form-item label="状态">
        <el-select v-model="state.form.status" class="m-2" @change="handleChangeSelect">
          <el-option
            v-for="item in state.typeOptions"
            :key="item.value"
            class="w-percent-100"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click.stop="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave">确认</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { reactive, ref, getCurrentInstance } from 'vue'
  import { reqUpdateDiscountCodeStatus, updateDiscountCodeEnableStatus } from '@/api/exhibitionManage'
  import { debounce } from '@/utils/debounce'
  const props = defineProps({
    title: {
      type: String,
      default: '更改状态',
    },
  })
  const { proxy } = getCurrentInstance()
  const dialogFormVisible = ref(false)
  const state = reactive({
    form: {
      id: '',
      status: '',
    },
    typeOptions: [
      {
        label: '启用',
        value: true,
      },
      {
        label: '停用',
        value: false,
      },
    ],
    rules: {
      status: [
        {
          required: true,
          trigger: 'blur',
          message: '请输入数量',
        },
      ],
    },
  })
  const emit = defineEmits(['noticeRefresh'])
  const handleResetForm = () => {
    state.form = {
      id: '',
      status: '',
    }
  }
  // 下拉事件
  const handleChangeSelect = (e) => {
    state.form.status = e
  }
  // 关闭
  const handleClose = () => {
    dialogFormVisible.value = false
  }
  // 打开
  const handleOpen = (row = {}) => {
    // 重置表单
    handleResetForm()
    state.form.id = row.id || ''
    state.form.status = row.status || ''
    dialogFormVisible.value = true
  }
  // 保存
  const handleSave = debounce(async () => {
    let resp = await updateDiscountCodeEnableStatus(state.form.id, state.form.status)
    proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
    emit('noticeRefresh')
    handleClose()
  })
  defineExpose({
    handleClose,
    handleOpen,
  })
</script>
